module.exports = __webpack_public_path__ + "static/grit-fffe741017678ad823f80057ad1eb112.jpg";